import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CalendarIcon, MoonIcon, BedIcon, SmileIcon, FlowerIcon, ClipboardCheckIcon, TrendingUpIcon, GiftIcon, BookOpenIcon } from 'lucide-react';
export function TemplatesSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const templates = [{
    icon: CalendarIcon,
    number: '1',
    title: 'Calendario 28 días con fases lunares',
    color: 'purple-main'
  }, {
    icon: MoonIcon,
    number: '2',
    title: 'Registro calorones nocturnos (hora/trigger/acción)',
    color: 'coral'
  }, {
    icon: BedIcon,
    number: '3',
    title: 'Diario sueño menopáusico (rituales + despertares)',
    color: 'lavender'
  }, {
    icon: SmileIcon,
    number: '4',
    title: 'Tracker humor matutino (triggers familia)',
    color: 'sage'
  }, {
    icon: FlowerIcon,
    number: '5',
    title: 'Planner remedios abuela (10 culturales)',
    color: 'terracotta'
  }, {
    icon: ClipboardCheckIcon,
    number: '6',
    title: 'Hoja "Mi Día Sin Drama" checklists',
    color: 'purple-deep'
  }, {
    icon: TrendingUpIcon,
    number: '7',
    title: 'Resumen semanal progreso',
    color: 'coral'
  }];
  const bonuses = [{
    icon: GiftIcon,
    title: '10 remedios colombianos/mexicanos + stickers digitales'
  }, {
    icon: BookOpenIcon,
    title: 'Guía "Empieza Hoy" ejemplos reales'
  }];
  return <section ref={ref} className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-249">
      <div className="max-w-6xl mx-auto" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-251">
          <h2 className="text-purple-deep text-4xl sm:text-5xl md:text-6xl font-bold font-heading mb-6" data-id="element-252">
            Lo que recibes:
          </h2>
          <p className="text-gray-700 text-xl sm:text-2xl" data-id="element-253">
            7 templates profesionales + bonuses culturales
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-254">
          {templates.map((template, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-gradient-to-br from-purple-50 to-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border-2 border-lavender/30" data-id="element-255">
              <div className="flex items-start gap-4" data-id="element-256">
                <div className={`flex-shrink-0 w-12 h-12 rounded-full bg-${template.color}/20 flex items-center justify-center`} data-id="element-257">
                  <template.icon className={`w-6 h-6 text-${template.color}`} data-id="element-258" />
                </div>
                <div data-id="element-259">
                  <div className="text-purple-main text-sm font-bold mb-1" data-id="element-260">
                    Template {template.number}
                  </div>
                  <p className="text-gray-800 text-lg font-semibold leading-snug" data-id="element-261">
                    {template.title}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="bg-gradient-to-r from-coral/10 via-terracotta/10 to-coral/10 rounded-3xl p-8 sm:p-12" data-id="element-262">
          <h3 className="text-purple-deep text-3xl sm:text-4xl font-bold font-heading mb-8 text-center" data-id="element-263">
            🎁 Bonuses Incluidos:
          </h3>
          <div className="grid sm:grid-cols-2 gap-6" data-id="element-264">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 1 + index * 0.2
          }} className="flex items-center gap-4 bg-white rounded-xl p-6 shadow-md" data-id="element-265">
                <bonus.icon className="w-10 h-10 text-coral flex-shrink-0" data-id="element-266" />
                <p className="text-gray-800 text-lg font-semibold" data-id="element-267">
                  {bonus.title}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}